import WhitelistRepository from '../../../networking/repos/WhitelistRepository';
import {useQueryConfig} from '../Utils';

export const WhitelistQueryKey = {
    base: ['whitelist'],
};

export const useWhitelistIndexQueryConfig = () => {
    const repo = new WhitelistRepository();

    return useQueryConfig(WhitelistQueryKey.base, () => repo.all());
};
